import api from "@helpers/api";

const apiEndPoint = `http://127.0.0.1:7077/employees/10/gpf-loans`;

export const createNewLoan = (() => {
  return async (data: any): Promise<{ data: any }> => {
    const {
      loanId,
      loanAmount,
      loanIssueDate,
      approvedGpfLoanApplication,
      associateDocuments,
    } = data;

    return api
      .post(apiEndPoint, {
        loanId,
        loanAmount,
        loanIssueDate,
        approvedGpfLoanApplication: [{ ...approvedGpfLoanApplication }],
        associateDocuments: [{ ...associateDocuments }],
      })
      .then((response) => {
        return { data: response.data };
      });
  };
})();
